import { useMemo } from 'react'

import { connectionStateObserver } from '@livekit/components-core'
import type { Room } from 'livekit-client'

import { useEnsureRoom } from '@/src/context'

import { useObservableState } from '@/src/hooks/internal'

/**
 * The `useConnectionState` hook allows you to simply implement your own `ConnectionState` component.
 *
 * @example
 * ```tsx
 * const connectionState = useConnectionState(room);
 * ```
 * @public
 */
export function useConnectionState(room?: Room) {
  // passed room takes precedence, if not supplied get current room context
  const r = useEnsureRoom(room)
  const observable = useMemo(() => connectionStateObserver(r), [r])
  const connectionState = useObservableState(observable, r.state)
  return connectionState
}
